/* global window:true */

import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';
import ReactGA from 'react-ga';

import ProfileSettingsForm from '../forms/ProfileSettingsForm';

const TITLE = 'Profile settings';

class ProfileSettingsPage extends Component {
    componentDidMount() {
        const { actions } = this.props;

       // set breadcrumb
        actions.setBreadcrumb([{ title: TITLE }]);

       // log analytics
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        const { profile, actions } = this.props;

        return (
            <div className="portfolio-wrapper index-1">
                <Helmet title={TITLE} />
                <div className="section-name index-1 container">
                    <div className="col-md-12 resources-title">
                        <h1>{TITLE}</h1>
                        <div className="sep" />
                    </div>
                </div>

                <div className="container" style={{ marginTop: '30px' }}>
                    <div className="login-block" id="school-account">
                        <ProfileSettingsForm profile={profile} handleSubmit={actions.profileUpdateRequest} />
                    </div>
                </div>
            </div>
        );
    }
}

ProfileSettingsPage.propTypes = {
    actions: PropTypes.object,
    profile: PropTypes.object
};

export default ProfileSettingsPage;



/** WEBPACK FOOTER **
 ** ./src/pages/ProfileSettingsPage.js
 **/